namespace GeniuzPOS.PosShift {
    export interface PsPosShiftControlViewRow {
        Id?: number;
        SingInDate?: string;
        SingInTime?: string;
        SingOutDate?: string;
        SingOutTime?: string;
        ShiftStatus?: string;
        PosId?: string;
        ShopId?: string;
        ShopFullName?: string;
        CashierId?: string;
        StartReceiptNo?: string;
        EndReceiptNo?: string;
        StartRefundNo?: string;
        EndRefundNo?: string;
        BegCash?: number;
        CashIn?: number;
        CashOut?: number;
        CashSales?: number;
        RoundReceive?: number;
        CashBalance?: number;
        GrossAmt?: number;
        Deiscount?: number;
        NetSales?: number;
        Charge?: number;
        RecvByCash?: number;
        RecvByCoupon?: number;
        RecvByCreditCd?: number;
        RecvByDebitCd?: number;
        RecvByPoint?: number;
        RecvByCashCd?: number;
        RecvByQr?: number;
        RecvByCurrency?: number;
        RecvByOthers?: number;
        CountVoid?: number;
        CountCancel?: number;
        CountOpenDrawer?: number;
        CountCashIn?: number;
        CountCashOut?: number;
        CountRefund?: number;
        TotalVoidAmt?: number;
        TotalCashInAmt?: number;
        TotalCashOutamt?: number;
        TotalRefundAmt?: number;
        CreateBy?: string;
        CreateDate?: string;
        UpdateBy?: string;
        LastUpdate?: string;
    }

    export namespace PsPosShiftControlViewRow {
        export const idProperty = 'Id';
        export const nameProperty = 'ShiftStatus';
        export const localTextPrefix = 'PosShift.PsPosShiftControlView';
        export const lookupKey = 'PosShift.PsPosShiftControlView';

        export function getLookup(): Q.Lookup<PsPosShiftControlViewRow> {
            return Q.getLookup<PsPosShiftControlViewRow>('PosShift.PsPosShiftControlView');
        }
        export const deletePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานสถานะกะแคชเชียร์:View';
        export const insertPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานสถานะกะแคชเชียร์:View';
        export const readPermission = '1POSBASE:รายงาน:รายวันขาย:รายงานสถานะกะแคชเชียร์:View';
        export const updatePermission = '1POSBASE:รายงาน:รายวันขาย:รายงานสถานะกะแคชเชียร์:View';

        export declare const enum Fields {
            Id = "Id",
            SingInDate = "SingInDate",
            SingInTime = "SingInTime",
            SingOutDate = "SingOutDate",
            SingOutTime = "SingOutTime",
            ShiftStatus = "ShiftStatus",
            PosId = "PosId",
            ShopId = "ShopId",
            ShopFullName = "ShopFullName",
            CashierId = "CashierId",
            StartReceiptNo = "StartReceiptNo",
            EndReceiptNo = "EndReceiptNo",
            StartRefundNo = "StartRefundNo",
            EndRefundNo = "EndRefundNo",
            BegCash = "BegCash",
            CashIn = "CashIn",
            CashOut = "CashOut",
            CashSales = "CashSales",
            RoundReceive = "RoundReceive",
            CashBalance = "CashBalance",
            GrossAmt = "GrossAmt",
            Deiscount = "Deiscount",
            NetSales = "NetSales",
            Charge = "Charge",
            RecvByCash = "RecvByCash",
            RecvByCoupon = "RecvByCoupon",
            RecvByCreditCd = "RecvByCreditCd",
            RecvByDebitCd = "RecvByDebitCd",
            RecvByPoint = "RecvByPoint",
            RecvByCashCd = "RecvByCashCd",
            RecvByQr = "RecvByQr",
            RecvByCurrency = "RecvByCurrency",
            RecvByOthers = "RecvByOthers",
            CountVoid = "CountVoid",
            CountCancel = "CountCancel",
            CountOpenDrawer = "CountOpenDrawer",
            CountCashIn = "CountCashIn",
            CountCashOut = "CountCashOut",
            CountRefund = "CountRefund",
            TotalVoidAmt = "TotalVoidAmt",
            TotalCashInAmt = "TotalCashInAmt",
            TotalCashOutamt = "TotalCashOutamt",
            TotalRefundAmt = "TotalRefundAmt",
            CreateBy = "CreateBy",
            CreateDate = "CreateDate",
            UpdateBy = "UpdateBy",
            LastUpdate = "LastUpdate"
        }
    }
}
